import { TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR } from '../actionConstants';

export const actionSetHasShownMultipackMessageFor = (itemIds: string[]) => ({
  type: TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR,
  payload: { hasShownMultipackMessageFor: itemIds },
});

export const clearHasShownMultipackMessageFor = () => ({
  type: TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR,
  payload: { hasShownMultipackMessageFor: [] },
});
